import { t } from "@lingui/macro";
import * as React from "react";
import { Path } from "react-native-svg";

import { Icon, IconProps } from "../../../primitive";

export const AquaticsIcon = (props: IconProps) => (
  <Icon
    viewBox="0 0 16 16"
    fill="none"
    color="#001A19"
    title={t`Aquatics`}
    {...props}
  >
    <Path
      stroke="currentColor"
      strokeLinecap="round"
      strokeWidth={1.5}
      d="M1 12.778h.983a1.6 1.6 0 0 0 1.258-.628l.384-.491a1.095 1.095 0 0 1 1.75 0 1.095 1.095 0 0 0 1.75 0 1.095 1.095 0 0 1 1.75 0 1.095 1.095 0 0 0 1.75 0 1.095 1.095 0 0 1 1.75 0l.384.49a1.6 1.6 0 0 0 1.258.629H15"
      fill="none"
    />
    <Path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M13.56 3.44a1.5 1.5 0 1 1-2.12 2.12 1.5 1.5 0 0 1 2.12-2.12ZM2 4h4.444L12 9M9 7 6 9"
      fill="none"
    />
  </Icon>
);
